export class Address {
  constructor({
    addressID = 0,
    streetAddress = null,
    suburb = null,
    state = null,
    postCode = null,
    customerID = 0,
    searchResultId = 0,
    formattedAddress = null,
  } = {}) {
    this.addressID = addressID;
    this.streetAddress = streetAddress;
    this.suburb = suburb;
    this.state = state;
    this.postCode = postCode;
    this.customerID = customerID;
    this.searchResultId = searchResultId;
    this.formattedAddress = formattedAddress;
  }
}

export function createAddress(data) {
  return Object.freeze(new Address(data));
}
